import { jsx as _jsx } from "react/jsx-runtime";
import { TitleSizes, TitleVariants } from "./constants";
import StyledTitle from "./Title.style";
const Title = ({ children, variant = TitleVariants.default, size = TitleSizes.base, ...props }) => (_jsx(StyledTitle, { variant: variant, size: size, ...props, children: children }));
export default Title;
//# sourceMappingURL=Title.js.map